import 'slick-carousel';

const MOBILE_BREAKPOINT = 740;

export default function initSlider() {
  const tutorsSlider = jQuery('.tutors-slider');
  const coursesSlider = jQuery('.courses-slider');
  const mobileSlider = jQuery('.mobile-slider');
  const teachersSlider = jQuery('.teachers-slider');
  const testimonialsSlider = jQuery('.testimonials-slider');

  if (!tutorsSlider.length && !coursesSlider.length && !mobileSlider.length && !teachersSlider.length && !testimonialsSlider.length) {
    return;
  }

  const prevArrow = `
    <button type="button" class="slick arrow slick-prev">
      <span class="visually-hidden">Предыдущий слайд</span>
      <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M24.6654 13.6513H1.33203M1.33203 13.6513L12.9987 25.318M1.33203 13.6513L12.9987 1.98468" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  `;

  const nextArrow = `
    <button type="button" class="slick arrow slick-next">
      <span class="visually-hidden">Следующий слайд</span>
      <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M24.6654 13.6513H1.33203M1.33203 13.6513L12.9987 25.318M1.33203 13.6513L12.9987 1.98468" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  `;

  const defaultSliderConfig = {
    variableWidth: true,
    centerMode: false,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
  };

  const responsiveConfig = [
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
      },
    },
  ];

  const sliders = [tutorsSlider, coursesSlider, teachersSlider, testimonialsSlider];
  sliders.forEach((slider) => {
    if (slider.length) {
      slider.slick({
        ...defaultSliderConfig,
        responsive: responsiveConfig,
      });
      slider.on('beforeChange', function () {
        jQuery('.slick-slider').removeClass('slick-arrow-clicked');
        jQuery(this).addClass('slick-arrow-clicked');
      });
    }
  });

  const initMobileSlider = () => {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
    const isInitialized = mobileSlider.hasClass('slick-initialized');

    if (isInitialized && !isMobile) {
      mobileSlider.slick('unslick');
    } else if (!isInitialized && isMobile) {
      mobileSlider.slick(defaultSliderConfig);
    }
  };

  initMobileSlider();

  jQuery(window).on('resize', initMobileSlider);
}
